import React from "react";
import { Box, Typography } from "@mui/material";
import {
  formatM365ClientSecretExpiryCaption,
  m365ClientSecretExpiryTone,
  type M365ClientSecretExpiry,
} from "../../utils/m365ClientSecretExpiry";

const TONE_COLOR = {
  error: "#dc2626",
  warning: "#b45309",
  neutral: "#666F8D",
};

interface M365ClientSecretExpiryCaptionProps {
  expiry: M365ClientSecretExpiry | null;
  loading?: boolean;
  pendingNewSecret?: boolean;
}

const M365ClientSecretExpiryCaption: React.FC<
  M365ClientSecretExpiryCaptionProps
> = ({ expiry, loading = false, pendingNewSecret = false }) => {
  let text = "";
  let tone: keyof typeof TONE_COLOR = "neutral";
  if (pendingNewSecret) {
    text = "Test the new secret to see its expiry date.";
  } else if (loading && !expiry) {
    text = "Checking expiry…";
  } else {
    text = formatM365ClientSecretExpiryCaption(expiry);
    tone = m365ClientSecretExpiryTone(expiry);
  }
  if (!text) return null;
  return (
    <Box sx={{ mt: 0.75 }}>
      <Typography
        sx={{
          color: TONE_COLOR[tone],
          fontSize: "12px",
          fontFamily: "var(--theo-font-sans)",
          lineHeight: 1.4,
          fontWeight: tone === "neutral" ? 500 : 600,
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};

export default M365ClientSecretExpiryCaption;
